<div property="schema:text" class="aboutUs-container">
  <div class="abUs-banner">
    <img src="../../../../assets/images/abUs-banner.png" />
  </div>
  <div class="row p-text">
    <div class="col-12">
      <p>Every morning, millions of Nigerians wake up to face a brutal reality: unemployment. It is not just a
        statistic but a fight defining people, families, and communities. Despite having the desire, talent, and
        ambition, countless Nigerians remain without meaningful means of livelihood. At Worknigeria, we refuse to
        accept this as the status quo. Our vision is simple yet powerful: to put Nigerians back to work.</p>
      <p class="m-0">As a subsidiary of The Innovate Africa Foundation, Worknigeria was founded in 2021 with the
        mission to help the huge Nigerian workforce find not only employment but also opportunities to develop their
        skills in their chosen careers. With advanced technology and strategic partnerships, we are establishing a
        platform where careers thrive and businesses find the talent they need.</p>
    </div>
  </div>

  <!-- Vision and Mission Section -->
  <div class="vision-mission">
    <!-- vision card -->
    <div class="vision-card">
      <div class="vision-mission-header">
        <div class="icon-wrapper">
          <div class="vision-icon">
            <img src="../../../../assets/images/vision-card-icon.png" alt="Vision Icon" />
          </div>
        </div>
        <h3>Our Vision</h3>
      </div>

      <p>
        <b>To put one million Nigerians to work every year.</b><br>
        In a society where unemployment looms as a serious concern, this vision offers more than simply a goal—it is a promise.
      </p>
      <p>
        A promise to improve lives, spark ambitions, and rebuild the Nigerian workforce, one job at a time. At Worknigeria, we believe that meaningful employment is the cornerstone of a functioning society, and we are on a relentless path to making this a reality for millions of Nigerians. management software provides full automation of membership renewals and payments
      </p>
    </div>
    
    <!-- mission card -->
    <div class="mission-card">
      <div class="vision-mission-header">
        <div class="icon-wrapper">
          <div class="mission-icon">
            <img src="../../../../assets/images/mission-card-icon.png" alt="Mission Icon" />
          </div>
        </div>
        <h3>Our Mission</h3>
      </div>

      <p>
        To serve both our corporate clients and job seekers with passion and devotion by offering them a range of specialized services that ultimately help us put one million Nigerians to work each year.<br>
        Our mission is anchored in the understanding that true change happens when everyone wins.
      </p>
      <p>
        For job seekers, this means creating access to opportunities that match their talents and aspirations. For businesses, it is about delivering excellent people and bespoke recruitment solutions. Together, we are bridging the gap between potential and opportunity, paving the road for a stronger, more prosperous Nigeria.
      </p>
    </div>
  </div>

  <!-- What we do Section -->
  <div class="what-we-do">
    <h1>What we do</h1>
    
    <p class='what-we-do-text'>
      We offer experience, creativity, and a human touch to all facets of your workforce management, from hiring to employee engagement, payroll administration, and policy development. Together, we can turn obstacles into opportunities and create a vibrant, creative company via:
    </p>

    <!-- cards -->
    <div class="row">
      <div *ngFor="let item of whatWeDoList" class="col-12 col-lg-4 mb-4">
        <div class="what-we-do-card">
          <div class="what-we-do-icon">
            <img src="{{item.icon}}" />
          </div>

          <div>
            <h3>{{item.heading}}</h3>
            <p>{{item.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Why choose worknigeria Section -->
  <div class="why-choose">
    <div class="row">
      <div class="col-lg-6 why-choose-text">
        <h2>Why choose Worknigeria?</h2>
        <p>We are not just another recruitment platform. We are a community of individuals and businesses working
          together for a better future.</p>
        <ul class="custom-list">
          <li *ngFor="let item of items">
            <h4>{{ item.heading }}</h4>
            <p>{{ item.para }}</p>
          </li>
        </ul>
        <!-- <button (click)="goToSignUp()">Get Started Now</button> -->
      </div>
      <div class="col-lg-6 why-choose-img">
        <img src="../../../../assets/images/why-choose-us.webp" />
      </div>
    </div>
  </div>

  <!-- Contact Section -->
  <div class="contact-section">
    <div class="container">
      <div class="contact-header">
        <h2>Get in Touch</h2>
        <p>Want to learn more about any of our services</p>
      </div>

      <div class="row">
        <!-- Contact Form -->
        <div class="col-lg-6 col-md-12">
          <div class="contact-form-wrapper">
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
              
              <!-- Purpose Dropdown -->
              <div class="form-group">
                <select 
                  class="form-control" 
                  formControlName="purpose"
                  [class.is-invalid]="contactForm.get('purpose')?.invalid && contactForm.get('purpose')?.touched">
                  <option value="" disabled selected>Purpose</option>
                  <option value="recruitment">Recruitment Services</option>
                  <option value="job-seeking">Job Seeking</option>
                  <option value="partnership">Partnership Opportunity</option>
                  <option value="general">General Inquiry</option>
                  <option value="other">Other</option>
                </select>
                <div class="invalid-feedback" *ngIf="contactForm.get('purpose')?.invalid && contactForm.get('purpose')?.touched">
                  Please select a purpose
                </div>
              </div>

              <!-- Email Input -->
              <div class="form-group">
                <input 
                  type="email" 
                  class="form-control" 
                  placeholder="Your Email"
                  formControlName="email"
                  [class.is-invalid]="contactForm.get('email')?.invalid && contactForm.get('email')?.touched">
                <div class="invalid-feedback" *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched">
                  <span *ngIf="contactForm.get('email')?.errors?.['required']">Email is required</span>
                  <span *ngIf="contactForm.get('email')?.errors?.['email']">Please enter a valid email</span>
                </div>
              </div>

              <!-- Message Textarea -->
              <div class="form-group">
                <textarea 
                  class="form-control" 
                  rows="6" 
                  placeholder="Your Message"
                  formControlName="message"
                  [class.is-invalid]="contactForm.get('message')?.invalid && contactForm.get('message')?.touched"></textarea>
                <div class="invalid-feedback" *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched">
                  Message is required
                </div>
              </div>

              <!-- Submit Button -->
              <button 
                type="submit" 
                class="btn btn-send"
                [disabled]="contactForm.invalid || isSubmitting">
                <span *ngIf="!isSubmitting">Send Message</span>
                <span *ngIf="isSubmitting">Sending...</span>
              </button>

            </form>
          </div>
        </div>

        <!-- Contact Information -->
        <div class="col-lg-6 col-md-12">
          <div class="contact-info-wrapper">
            
            <!-- Email Us -->
            <div class="contact-info-card">
              <div class="info-icon email-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22 6L12 13L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="info-content">
                <h4>Email Us</h4>
                <a href="mailto:helpdesk@worknigeria.com">helpdesk@worknigeria.com</a>
              </div>
            </div>

            <!-- Call Us -->
            <div class="contact-info-card">
              <div class="info-icon call-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92V19.92C22 20.48 21.54 20.93 20.97 20.92C10.06 20.41 3.59 13.94 3.08 3.03C3.07 2.46 3.52 2 4.08 2H7.08C7.64 2 8.09 2.46 8.09 3.02C8.09 4.11 8.24 5.16 8.52 6.17C8.62 6.52 8.51 6.89 8.24 7.16L6.5 8.9C8.07 12.45 11.55 15.93 15.1 17.5L16.84 15.76C17.11 15.49 17.48 15.38 17.83 15.48C18.84 15.76 19.89 15.91 20.98 15.91C21.54 15.91 22 16.36 22 16.92Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="info-content">
                <h4>Call Us</h4>
                <a href="tel:+2349137000206">+2349137000206</a>
              </div>
            </div>

            <!-- Visit Us -->
            <div class="contact-info-card">
              <div class="info-icon location-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="info-content">
                <h4>Visit Us</h4>
                <p>11B Rev. Ogunbiyi Street, GRA Ikeja, Ikeja Lagos</p>
              </div>
            </div>

            <!-- Download Brochure -->
            <div class="contact-info-card brochure-card">
              <div class="info-icon download-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="info-content">
                <h4>Download Our Brochure</h4>
                <p class='text-decoration-underline cursor-pointer' (click)='downloadBrochure()'>Click here to download our brochure</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Awards and Certifications Section -->
  <div class="awards">
    <h2>Award and Certifications</h2>
    <div class="row d-flex align-items-center">
      <div class="col-lg-7 awards-text">
        <p>Our drive to excellence has garnered us various medals and certifications, reflecting our commitment to
          quality and innovation. From industry honors to important certifications like ISO, these achievements
          underline our unwavering quest of delivering great solutions and upholding the highest standards in
          everything we do.</p>
      </div>
      <div class="col-lg-5">
        <img src="../../../../assets/images/iso-certification.png" />
      </div>
    </div>
  </div>
  <!-- Trusted by Section -->
  <div class="trusted-by-section">
    <h2>Trusted by leading Employers in Nigeria:</h2>
    <p>We are proud to partner with various clients across industries who trust us to deliver great solutions
      tailored to their particular needs. Our client base shows our commitment to quality, innovation, and
      excellence.</p>
    <div class="ticker-outer-container">
      <div class="ticker-inner-container">
        <div class="ticker-container">
          <div *ngFor="let logo of logos" class="ticker-item">
            <img [src]="logo" class="ticker-img" alt="Logo" />
          </div>
          <div *ngFor="let logo of logos" class="ticker-item">
            <img [src]="logo" class="ticker-img" alt="Logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Testimonials Section -->
  <div class="testimonials-section">
    <h2>Testimonials</h2>
    <p>These are just few testimonials from what our users have said about us</p>
    <!-- Testimonials Cards -->
    <div class="cards-container">
      <div class="card testimonials-card" *ngFor="let card of testimonials let i = index">
        <img [src]="card.logo" alt="{{ card.heading }}" />
        <h4> {{ card.heading }} </h4>
        <p class="m-0"> {{ card.para }} </p>
        <p> {{ card.saidBy }} </p>
        <p class="learn-more" (click)="goToSignUp()">Learn More →</p>
      </div>
    </div>
  </div>
  <!-- Our values Section -->
  <div class="our-values">
    <h2>Our Values</h2>
    <div class="row">
      <div class="col-lg-6 our-values-img">
        <img src="../../../../assets/images/values-icon.webp" />
      </div>
      <div class="col-lg-6 our-values-text">
        <p>We recognize that our success as a Human Resource Consulting firm in Nigeria is intricately linked to the
          well-being, development, and fulfillment of each team member as well as to delivering excellent customer
          satisfaction.</p>
        <p>Thus, our company culture is generally founded on the principles of collaboration, innovation, leadership,
          excellence, and integrity. These values are not just words on paper; they are also the guiding light behind
          everything we do, shaping our decisions, actions, and relationships.</p>
        <ul>Itemized below are the key tenets of our culture…
          <li>Our People First</li>
          <li>Customer Satisfaction</li>
          <li>Continuous Learning and Improvement</li>
          <li>Empowerment and Ownership</li>
          <li>Team Collaboration and Support</li>
          <li>Corporate Social Responsibility</li>
          <li>Resilience</li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Join Us Section -->
  <div class="join-us">
    <div class="row">
      <div class="col-lg-6 join-us-text">
        <h2>Join Us</h2>
        <p>Whether you’re an employer seeking the perfect talent or a job seeker ready to take the next step in your 
          career, Worknigeria is here for you. Together, we can transform the future of work in Nigeria.</p>
        <!-- <button (click)="goToSignUp()">Join Us Now</button> -->
      </div>
      <div class="col-lg-6 join-us-img">
        <img src="../../../../assets/images/join-us-img.webp" />
      </div>
    </div>
  </div>
</div>